// extracted by mini-css-extract-plugin
export default {"title":"c5-z","warning":"d5-z","sizeOptionsLegendText":"e5-z"};